import { gql } from '@apollo/client'

export const getPropertyUnitsQuery = gql`
  query ($propertyID: GraphQLORID!) {
    getPropertyUnits(propertyID: $propertyID) {
      propertyID
      unitNumber
      numBaths
      numBeds
      occupancy
      targetRent
      totalArea
      status
      propertyDisplayName
      image {
        imageUrl
      }
    }
  }
`
